module.exports = __webpack_public_path__ + "static/media/23.ecae070f.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/accessoires/23.png
// module id = 390
// module chunks = 0